(() => {
  function init(root = document) {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduce && 'IntersectionObserver' in window) {
      document.documentElement.classList.add('sd-motion');
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { const row = entry.target.parentElement; if (row) row.querySelectorAll(':scope > .sd-reveal.sd-pending').forEach(el => { el.classList.remove('sd-pending'); observer.unobserve(el); }); entry.target.classList.remove('sd-pending'); observer.unobserve(entry.target); }
      }), { threshold: 0, rootMargin: '0px 0px 15% 0px' });
      root.querySelectorAll('.sd-reveal:not([data-sd-observed])').forEach(el => {
        el.dataset.sdObserved = 'true';
        if (el.getBoundingClientRect().top > window.innerHeight) el.classList.add('sd-pending');
        observer.observe(el);
      });
    }
    root.querySelectorAll('[data-sd-demo]:not([data-sd-bound])').forEach(button => {
      button.dataset.sdBound = 'true';
      button.addEventListener('click', () => {
        const dialog = document.getElementById(button.dataset.sdDemo);
        if (dialog && !dialog.open) dialog.showModal();
      });
    });
    root.querySelectorAll('.sd-demo-dialog:not([data-sd-bound])').forEach(dialog => {
      dialog.dataset.sdBound = 'true';
      dialog.querySelector('[data-sd-close]')?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    });
    root.querySelectorAll('[data-sd-sort]:not([data-sd-bound])').forEach(select => {
      select.dataset.sdBound = 'true';
      select.addEventListener('change', () => select.form.requestSubmit());
    });
  }
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', event => init(event.target));
  let cartRequest;
  document.addEventListener('cart:update', async () => {
    cartRequest?.abort();
    cartRequest = new AbortController();
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart.js', {signal: cartRequest.signal});
      if (!response.ok) return;
      const cart = await response.json();
      document.querySelectorAll('.sd-header-cart-count').forEach(el => el.textContent = '(' + cart.item_count + ')');
    } catch (error) {
      if (error.name !== 'AbortError') return;
    }
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.sd-menu[open]').forEach(menu => menu.open = false);
  });
})();

document.addEventListener('submit', async event => {
  const form = event.target.closest('[data-sd-quick-add]');
  if (!form) return;
  event.preventDefault();
  const button = form.querySelector('button');
  if (button.disabled) return;
  const status = form.closest('.sd-perfume-card').querySelector('[data-sd-add-status]');
  button.disabled = true;
  button.setAttribute('aria-busy', 'true');
  status.textContent = '';
  try {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(root + 'cart/add.js', {method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || form.dataset.error);
    status.textContent = form.dataset.success;
    document.dispatchEvent(new CustomEvent('cart:update', {detail:{source:'sd-quick-add',item:result}}));
  } catch (error) {
    status.textContent = error.message || form.dataset.error;
  } finally {
    button.disabled = false;
    button.removeAttribute('aria-busy');
  }
});
